import * as types from '../ActionTypes/SearchWorkoutActionTypes';
import { getWorkoutModelsArray } from './helpers';

const intialState = {
    loading: false,
    loaded: false,
    fail: false,
    errorMsg: null,
    offsetId: null,
    workouts: [],
};

export function SearchWorkoutsReducer(defaultState = intialState, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_ALL_WORKOUT:
            return { ...defaultState, loading: true, errorMsg: null };

        case types.GET_ALL_WORKOUT_SUCCESS: {
            const workoutsArray = getWorkoutModelsArray(payload.response);

            return {
                ...defaultState,
                loading: false,
                loaded: true,
                workouts: [...workoutsArray],
                offsetId: payload.offsetId,
            };
        }
        case types.GET_MORE_WORKOUT:
            return { ...defaultState, loaded: false };

        case types.GET_MORE_WORKOUT_SUCCESS: {
            const workoutsArray = getWorkoutModelsArray(payload.response);
            return {
                ...defaultState,
                loading: false,
                loaded: true,
                workouts: defaultState.workouts.concat(workoutsArray),
                offsetId: payload.offsetId,
            };
        }
        case types.GET_MORE_WORKOUT_EMPTY:
            return {
                ...defaultState,
                loading: false,
                loaded: true,
            };

        case types.GET_WORKOUT_FAIL:
            return {
                loading: false,
                loaded: false,
                fail: true,
                errorMsg: { ...payload.error },
                offsetId: null,
                workouts: [],
            };

        default:
            return defaultState;
    }
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/SearchWorkoutsReducer.js